import { IReportItem } from 'APIPackage/MainModule/interfaces/IReportItem';

export const erknmReportItems: Omit<IReportItem, 'name'>[] = [
  {
    type: 'ERKNM_PM_BY_KNO',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PM_BY_SUPERVISION_TYPE',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PM_PLANNED_BY_MONTH',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PM_CARRIED_OUT_BY_MONTH',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_KNM_CARRIED_OUT_BY_RF_REGION',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PM_CARRIED_OUT_BY_RF_REGION',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PM_DECISION_APPEALED',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_UNPLANNED_KNM_BY_KNO',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_UNPLANNED_KNM_BY_PROSECUTOR',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_UNPLANNED_KNM_BY_PROSECUTOR_AND_KNO',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_STATISTICS_BY_SUPERVISION_TYPE',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PLANNED_KNM_BY_PROSECUTOR',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_PLANNED_KNM_BY_KNO_AND_PROSECUTOR',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_STATISTICS_BY_REJECT_REASON_TYPE',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_KNM_DECISION_APPEALED',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_KNM_PLANNED_BY_MONTH',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_KNM_CARRIED_OUT_BY_MONTH',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_TOSER_AND_SEZ_REGISTER',
    service: 'REPORT',
  },
  {
    type: 'ERKNM_SPV_AND_TOR_REGISTER',
    service: 'REPORT',
  },
  {
    type: 'APPROVED_KNM_PLAN',
  },
  {
    type: 'KNM_FROM_SMEV_START_DATE',
  },
  {
    type: 'KNM_FROM_SMEV_RECEIVED_DATE',
  },
  {
    type: 'ERKNM_KIND_DECISION_TYPE_BY_PROSECUTOR_AND_KNO',
  },
  {
    type: 'ERKNM_ACT_VIOLATION_TYPE_BY_PROSECUTOR_AND_KNO',
  },
];
